import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "radioCard", "closeButton"]
  static values = {
    requiresSelection: Boolean
  }

  connect() {
    this.updateSubmitButton()
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.hasCloseButtonTarget) {
      event.preventDefault()
      this.closeButtonTarget.click()
    }
  }

  // Called when a radio card is selected
  selectCard(event) {
    const card = event.currentTarget
    const radio = card.querySelector('input[type="radio"]')

    if (radio) {
      radio.checked = true
      this.updateCardStyles()
      this.updateSubmitButton()
    }
  }

  // Update visual styles for all cards
  updateCardStyles() {
    this.radioCardTargets.forEach(card => {
      const radio = card.querySelector('input[type="radio"]')
      const isSelected = radio?.checked

      // Remove previous selection styles
      card.classList.remove(
        'border-primary-500', 'ring-2', 'ring-primary-500',
        'bg-primary-50', 'dark:bg-primary-900/20'
      )
      card.classList.add('border-gray-300', 'dark:border-gray-600')

      // Add selection styles if selected
      if (isSelected) {
        card.classList.remove('border-gray-300', 'dark:border-gray-600')
        card.classList.add(
          'border-primary-500', 'ring-2', 'ring-primary-500',
          'bg-primary-50', 'dark:bg-primary-900/20'
        )
      }
    })
  }

  // Enable/disable submit button based on selection
  updateSubmitButton() {
    if (!this.hasSubmitButtonTarget) return
    if (!this.requiresSelectionValue) return

    const hasSelection = this.radioCardTargets.some(card => {
      const radio = card.querySelector('input[type="radio"]')
      return radio?.checked
    })

    this.submitButtonTarget.disabled = !hasSelection

    if (hasSelection) {
      this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
      this.submitButtonTarget.classList.add('cursor-pointer')
    } else {
      this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
      this.submitButtonTarget.classList.remove('cursor-pointer')
    }
  }
}
